import {
  forwardRef,
  type InputHTMLAttributes,
  type SelectHTMLAttributes,
  type TextareaHTMLAttributes,
} from "react";
import { cn } from "@/lib/utils";

// text-base on phones keeps iOS from zooming into focused inputs. The focus edge is the
// ring colour (6:1 on white); the soft halo around it is decoration.
export const controlClass = cn(
  "w-full rounded-md border border-input bg-card px-3 py-2 text-base text-foreground shadow-sm outline-none transition-[border-color,box-shadow] md:text-sm",
  "placeholder:text-muted-foreground/80 hover:border-primary/40",
  "focus:border-ring focus:ring-[3px] focus:ring-ring/20",
  "disabled:cursor-not-allowed disabled:bg-muted disabled:opacity-70",
  "aria-[invalid=true]:border-destructive aria-[invalid=true]:focus:ring-destructive/20",
);

export const Input = forwardRef<HTMLInputElement, InputHTMLAttributes<HTMLInputElement>>(
  function Input({ className, ...props }, ref) {
    return <input ref={ref} className={cn(controlClass, "h-10", className)} {...props} />;
  },
);

export const Textarea = forwardRef<
  HTMLTextAreaElement,
  TextareaHTMLAttributes<HTMLTextAreaElement>
>(function Textarea({ className, rows = 3, ...props }, ref) {
  return <textarea ref={ref} rows={rows} className={cn(controlClass, className)} {...props} />;
});

export const Select = forwardRef<HTMLSelectElement, SelectHTMLAttributes<HTMLSelectElement>>(
  function Select({ className, ...props }, ref) {
    return <select ref={ref} className={cn(controlClass, "h-10 pr-8", className)} {...props} />;
  },
);
